// extracted by mini-css-extract-plugin
module.exports = {"formControls":"form-control_formControls__3eNct","submit":"form-control_submit__2Ij6j","reset":"form-control_reset__1uZsz"};